import React from "react";

const WordActionMenu = ({
  wordMenu,
  closeWordMenu,
  handleWordPlay,
  handleWordClick,
  segment,
}) => {
  if (!wordMenu) return null;

  return (
    <>
      <div className="fixed inset-0 z-30" onClick={closeWordMenu} />

      <div
        className="fixed z-50"
        style={{
          left: Math.min(wordMenu.rect.left, window.innerWidth - 220),
          top: wordMenu.rect.top + wordMenu.rect.height + 8,
        }}
      >
        <div className="bg-white/95 backdrop-blur-sm border border-white/40 shadow-lg rounded-xl px-2 py-2 flex items-center gap-2">
          <button
            onClick={() => {
              handleWordPlay(wordMenu.i, segment.words[wordMenu.i]);
              closeWordMenu();
            }}
            className="px-3 py-2 rounded-lg bg-white/60 hover:bg-white border border-white/40 text-sm font-medium"
          >
            ▶ Play
          </button>

          <button
            onClick={() => {
              handleWordClick(wordMenu.text);
              closeWordMenu();
            }}
            className="px-3 py-2 rounded-lg bg-white/60 hover:bg-white border border-white/40 text-sm font-medium"
          >
            🌐 Translate
          </button>
        </div>
      </div>
    </>
  );
};

export default WordActionMenu;